
































































import Vue from "vue";

import { mapState, mapGetters } from "vuex";

export default Vue.extend({
    name: "ProgressionStatus",
    props: {
        insideMobileContent: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data: function() {
        return {
            progressCircleRadius: 24 as number,
            progressCircleWidth: 8 as number,
            isMobile: true as boolean,
            listOpen: false as boolean,
        };
    },
    computed: {
        ...mapGetters("StepsWizard", [
            "currentGroup"
        ]),
        ...mapState("StepsWizard/progress", [
            "main",
            "mainMax",
            "sub",
            "subMax",
            "hasSub",
        ]),
        progressCircleCircumference: function(): number {
            return this.progressCircleRadius * 2 * Math.PI;
        },
        progressCircleCenter: function(): number {
            return this.progressCircleRadius + (this.progressCircleWidth / 2);
        },
        progressCircleCircumferenceOffset: function(): number {
            return this.progressCircleCircumference - (this.main * 100 / this.mainMax) / 100 * this.progressCircleCircumference;        
        },
        progressionCircleDiamater: function(): number {
            return this.progressCircleRadius * 2 + this.progressCircleWidth;
        }
    },
    mounted: function() {
        this.$responsive.registerMediaQuery("from-desktop", () => {
            this.isMobile = false;
            this.listOpen = true;
        }, () => {
            this.isMobile = true;
            this.listOpen = false;
        });
    },
    methods: {
        toggleList: function() {
            if (this.listOpen === true) {
                this.closeList();
            } else {
                this.openList();
            }
        },
        openList: function() {
            this.$emit("open-list");
        },
        closeList: function() {
            this.$emit("close-list");
        }
    },
});
